// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css/lib/js/src/Css.js");
var $$Array = require("bs-platform/lib/js/array.js");
var Block = require("bs-platform/lib/js/block.js");
var Curry = require("bs-platform/lib/js/curry.js");
var Theme = require("./theme");
var React = require("react");
var Network = require("./network");
var Storage = require("./storage");
var Caml_obj = require("bs-platform/lib/js/caml_obj.js");
var Caml_array = require("bs-platform/lib/js/caml_array.js");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");
var Calendar_iconSvg = require("./assets/calendar_icon.svg");
var Points_shieldSvg = require("./assets/points_shield.svg");
var Tipps_cta_iconSvg = require("./assets/tipps_cta_icon.svg");
var Points_star_iconSvg = require("./assets/points_star_icon.svg");
var Mahlzeit_cta_iconSvg = require("./assets/mahlzeit_cta_icon.svg");

var card = Css.style(/* :: */[
      Css.display(Css.flexBox),
      /* :: */[
        Css.fontSize(Theme.standardFontSize),
        /* [] */0
      ]
    ]);

var dashboard = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.width(/* `percent */[
              -119887163,
              100.0
            ]),
        /* :: */[
          Css.alignItems(Css.center),
          /* :: */[
            Css.position(/* relative */903134412),
            /* [] */0
          ]
        ]
      ]
    ]);

var flexList = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.flexDirection(Css.column),
        /* :: */[
          Css.alignItems(Css.stretch),
          /* [] */0
        ]
      ]
    ]);

var contentBox = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.width(/* `percent */[
              -119887163,
              100.0
            ]),
        /* :: */[
          Css.boxSizing(/* borderBox */9307263),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.padding4(Css.px(0), Css.px(12), Css.px(2), Css.px(12)),
              /* [] */0
            ]
          ]
        ]
      ]
    ]);

var vertBlock = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.alignItems(Css.center),
        /* :: */[
          Css.width(/* `percent */[
                -119887163,
                100.0
              ]),
          /* :: */[
            Css.margin4(Css.px(0), Css.px(0), Css.px(10), Css.px(0)),
            /* :: */[
              Css.borderTopLeftRadius(Css.px(10)),
              /* :: */[
                Css.borderTopRightRadius(Css.px(10)),
                /* :: */[
                  Css.borderBottomLeftRadius(Css.px(10)),
                  /* :: */[
                    Css.borderBottomRightRadius(Css.px(10)),
                    /* :: */[
                      Css.boxShadow(/* Some */[Css.px(1)], /* Some */[Css.px(2)], /* Some */[Css.px(4)], /* None */0, /* None */0, Css.rgba(244, 44, 123, 0.25)),
                      /* [] */0
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var headerBlock = Css.style(/* :: */[
      Css.margin4(Css.px(20), Css.px(0), Css.px(10), Css.px(0)),
      /* [] */0
    ]);

var horizontalBlock = Css.style(/* :: */[
      Css.flexDirection(Css.row),
      /* :: */[
        Css.justifyContent(Css.spaceAround),
        /* :: */[
          Css.width(/* `percent */[
                -119887163,
                100.0
              ]),
          /* [] */0
        ]
      ]
    ]);

var horizontalBlockTop = Css.style(/* :: */[
      Css.position(/* relative */903134412),
      /* :: */[
        Css.flexDirection(Css.row),
        /* :: */[
          Css.alignItems(Css.center),
          /* :: */[
            Css.justifyContent(Css.spaceAround),
            /* :: */[
              Css.background(Css.hex("FFFAFA")),
              /* :: */[
                Css.borderBottom(Css.px(2), /* solid */12956715, Css.hex("FCEBEC")),
                /* :: */[
                  Css.width(/* `percent */[
                        -119887163,
                        100.0
                      ]),
                  /* :: */[
                    Css.borderTopLeftRadius(Css.px(10)),
                    /* :: */[
                      Css.borderTopRightRadius(Css.px(10)),
                      /* :: */[
                        Css.height(Css.px(50)),
                        /* [] */0
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var horizontalBlockBottom = Css.style(/* :: */[
      Css.flexDirection(Css.row),
      /* :: */[
        Css.alignItems(Css.center),
        /* :: */[
          Css.margin4(Css.px(0), Css.px(0), Css.px(0), Css.px(0)),
          /* :: */[
            Css.justifyContent(Css.spaceAround),
            /* :: */[
              Css.width(/* `percent */[
                    -119887163,
                    100.0
                  ]),
              /* :: */[
                Css.background(Css.hex("00")),
                /* :: */[
                  Css.borderBottomLeftRadius(Css.px(10)),
                  /* :: */[
                    Css.borderBottomRightRadius(Css.px(10)),
                    /* :: */[
                      Css.padding2(Css.px(8), Css.px(0)),
                      /* [] */0
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var horizontalBlockInner = Css.style(/* :: */[
      Css.marginBottom(Css.px(3)),
      /* :: */[
        Css.marginTop(Css.px(8)),
        /* :: */[
          Css.fontWeight(700),
          /* :: */[
            Css.fontSize(Css.px(22)),
            /* [] */0
          ]
        ]
      ]
    ]);

var horizontalBlockInnerLeft = Css.style(/* :: */[
      Css.textTransform(/* uppercase */-415330030),
      /* [] */0
    ]);

var horizontalBlockInnerRight = Css.style(/* [] */0);

var inputHeader = Css.style(/* :: */[
      Css.marginBottom(Css.px(0)),
      /* :: */[
        Css.fontWeight(700),
        /* [] */0
      ]
    ]);

var inputField = Css.style(/* :: */[
      Css.margin4(Css.px(10), Css.px(0), Css.px(10), Css.px(0)),
      /* :: */[
        Css.padding2(Css.px(5), Css.px(5)),
        /* [] */0
      ]
    ]);

var someLink = Css.style(/* :: */[
      Css.fontSize(Theme.smallFontSize),
      /* :: */[
        Css.cursor(/* pointer */-786317123),
        /* :: */[
          Css.margin2(Css.px(5), Css.px(0)),
          /* [] */0
        ]
      ]
    ]);

function optButton(week, el) {
  var match = Caml_obj.caml_equal(week, el);
  return Css.style(/* :: */[
              match !== 0 ? Css.opacity(1.0) : Css.opacity(0.4),
              /* :: */[
                Css.margin4(Css.px(10), Css.px(0), Css.px(10), Css.px(0)),
                Theme.greenButtonRaw
              ]
            ]);
}

function settingButton() {
  return Css.style(/* :: */[
              Css.minWidth(Css.em(12.0)),
              /* :: */[
                Css.margin4(Css.px(10), Css.px(8), Css.px(10), Css.px(8)),
                Theme.greenButtonRaw
              ]
            ]);
}

var buttonBox = Css.style(/* :: */[
      Css.justifyContent(Css.center),
      /* :: */[
        Css.flexWrap(Css.wrap),
        /* [] */0
      ]
    ]);

var dashboardPointsBg = Css.style(/* :: */[
      Css.margin2(Css.px(0), Css.px(0)),
      /* :: */[
        Css.width(/* `percent */[
              -119887163,
              100.0
            ]),
        /* :: */[
          Css.position(/* absolute */-1013592457),
          /* [] */0
        ]
      ]
    ]);

function smallerRedSecondaryButton() {
  return Css.style(/* :: */[
              Css.minWidth(Css.px(100)),
              /* :: */[
                Css.maxWidth(Css.px(140)),
                /* :: */[
                  Css.width(/* `percent */[
                        -119887163,
                        100.0
                      ]),
                  /* :: */[
                    Css.height(Css.px(35)),
                    /* :: */[
                      Css.color(/* `hex */[
                            5194459,
                            "FF328C"
                          ]),
                      /* :: */[
                        Css.margin4(Css.px(2), Css.px(0), Css.px(2), Css.px(0)),
                        /* :: */[
                          Css.border(Css.px(1), /* solid */12956715, /* `hex */[
                                5194459,
                                "FF328C"
                              ]),
                          Theme.redButtonNarrowRaw
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]);
}

function smallerRedSecondaryButtonHigh() {
  return Css.style(/* :: */[
              Css.background(/* `hex */[
                    5194459,
                    "FFEEEF"
                  ]),
              /* :: */[
                Css.selector("&:hover", /* :: */[
                      Css.background(/* `hex */[
                            5194459,
                            "F8CDD0"
                          ]),
                      /* [] */0
                    ]),
                /* :: */[
                  Css.minWidth(Css.px(100)),
                  /* :: */[
                    Css.maxWidth(Css.px(140)),
                    /* :: */[
                      Css.width(/* `percent */[
                            -119887163,
                            100.0
                          ]),
                      /* :: */[
                        Css.height(Css.px(35)),
                        /* :: */[
                          Css.color(/* `hex */[
                                5194459,
                                "FF328C"
                              ]),
                          /* :: */[
                            Css.margin4(Css.px(2), Css.px(0), Css.px(2), Css.px(0)),
                            /* :: */[
                              Css.border(Css.px(1), /* solid */12956715, /* `hex */[
                                    5194459,
                                    "FF328C"
                                  ]),
                              Theme.redButtonNarrowRaw
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]);
}

function mediumGreenSecondaryButton() {
  return Css.style(/* :: */[
              Css.minWidth(Css.px(170)),
              /* :: */[
                Css.margin4(Css.px(8), Css.px(8), Css.px(8), Css.px(8)),
                /* :: */[
                  Css.flexGrow(1),
                  /* :: */[
                    Css.color(/* `hex */[
                          5194459,
                          "00C9C8"
                        ]),
                    /* :: */[
                      Css.height(Css.px(40)),
                      /* :: */[
                        Css.border(Css.px(1), /* solid */12956715, /* `hex */[
                              5194459,
                              "00C9C8"
                            ]),
                        Theme.greenSecondaryButtonRaw
                      ]
                    ]
                  ]
                ]
              ]
            ]);
}

var knowledgeWrapper = Css.style(/* :: */[
      Css.maxWidth(Css.px(180)),
      /* :: */[
        Css.flexGrow(1),
        /* :: */[
          Css.position(/* relative */903134412),
          /* [] */0
        ]
      ]
    ]);

var knowledgeInfo = Css.style(/* :: */[
      Css.borderRadius(/* `percent */[
            -119887163,
            50.0
          ]),
      /* :: */[
        Css.background(/* `hex */[
              5194459,
              "00C9C8"
            ]),
        /* :: */[
          Css.position(/* absolute */-1013592457),
          /* :: */[
            Css.height(Css.px(17)),
            /* :: */[
              Css.width(Css.px(17)),
              /* :: */[
                Css.top(Css.px(5)),
                /* :: */[
                  Css.right(Css.px(2)),
                  /* :: */[
                    Css.alignItems(/* center */98248149),
                    /* :: */[
                      Css.justifyContent(/* center */98248149),
                      /* [] */0
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var knowledgeInfoContent = Css.style(/* :: */[
      Css.textAlign(/* center */98248149),
      /* :: */[
        Css.fontSize(Css.px(12)),
        /* :: */[
          Css.color(Css.white),
          /* :: */[
            Css.fontWeight(700),
            /* :: */[
              Css.marginRight(Css.px(0)),
              /* :: */[
                Css.marginTop(Css.px(0)),
                /* :: */[
                  Css.alignSelf(/* center */98248149),
                  /* [] */0
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var headText = Css.style(/* :: */[
      Css.color(/* `hex */[
            5194459,
            "FF328C"
          ]),
      /* :: */[
        Css.fontSize(Css.px(18)),
        /* :: */[
          Css.fontWeight(700),
          /* [] */0
        ]
      ]
    ]);

var questionText = Css.style(/* :: */[
      Css.margin4(Css.px(10), Css.px(0), Css.px(10), Css.px(0)),
      /* :: */[
        Css.fontSize(Css.px(18)),
        /* :: */[
          Css.fontWeight(400),
          /* [] */0
        ]
      ]
    ]);

var pointsStarIcon = Css.style(/* :: */[
      Css.margin2(Css.px(0), Css.px(0)),
      /* :: */[
        Css.paddingRight(Css.px(8)),
        /* [] */0
      ]
    ]);

var calendarIcon = Css.style(/* :: */[
      Css.margin2(Css.px(0), Css.px(0)),
      /* :: */[
        Css.paddingBottom(Css.px(4)),
        /* :: */[
          Css.paddingRight(Css.px(8)),
          /* [] */0
        ]
      ]
    ]);

var pointsShield = Css.style(/* :: */[
      Css.margin2(Css.px(20), Css.px(0)),
      /* :: */[
        Css.position(/* absolute */-1013592457),
        /* :: */[
          Css.transform(/* `scale */[
                -120664438,
                /* tuple */[
                  1.6,
                  1.6
                ]
              ]),
          /* [] */0
        ]
      ]
    ]);

var pointsShieldH1 = Css.style(/* :: */[
      Css.margin4(Css.px(68), Css.px(0), Css.px(0), Css.px(0)),
      /* :: */[
        Css.zIndex(2),
        /* :: */[
          Css.lineHeight(1.0),
          /* [] */0
        ]
      ]
    ]);

var pointsShieldH3 = Css.style(/* :: */[
      Css.margin4(Css.px(0), Css.px(0), Css.px(10), Css.px(0)),
      /* :: */[
        Css.zIndex(2),
        /* :: */[
          Css.lineHeight(1.0),
          /* [] */0
        ]
      ]
    ]);

var Styles = /* module */[
  /* card */card,
  /* dashboard */dashboard,
  /* flexList */flexList,
  /* contentBox */contentBox,
  /* vertBlock */vertBlock,
  /* headerBlock */headerBlock,
  /* horizontalBlock */horizontalBlock,
  /* horizontalBlockTop */horizontalBlockTop,
  /* horizontalBlockBottom */horizontalBlockBottom,
  /* horizontalBlockInner */horizontalBlockInner,
  /* horizontalBlockInnerLeft */horizontalBlockInnerLeft,
  /* horizontalBlockInnerRight */horizontalBlockInnerRight,
  /* inputHeader */inputHeader,
  /* inputField */inputField,
  /* someLink */someLink,
  /* optButton */optButton,
  /* settingButton */settingButton,
  /* buttonBox */buttonBox,
  /* dashboardPointsBg */dashboardPointsBg,
  /* smallerRedSecondaryButton */smallerRedSecondaryButton,
  /* smallerRedSecondaryButtonHigh */smallerRedSecondaryButtonHigh,
  /* mediumGreenSecondaryButton */mediumGreenSecondaryButton,
  /* knowledgeWrapper */knowledgeWrapper,
  /* knowledgeInfo */knowledgeInfo,
  /* knowledgeInfoContent */knowledgeInfoContent,
  /* headText */headText,
  /* questionText */questionText,
  /* pointsStarIcon */pointsStarIcon,
  /* calendarIcon */calendarIcon,
  /* pointsShield */pointsShield,
  /* pointsShieldH1 */pointsShieldH1,
  /* pointsShieldH3 */pointsShieldH3
];

function text(prim) {
  return prim;
}

var component = ReasonReact.reducerComponent("Dashboard");

function make() {
  var syncNetworkData = function (param) {
    var send = param[/* send */4];
    var state = param[/* state */2];
    Network.initializeSyncStatus2(/* () */0);
    Network.pullData("", (function (data) {
            return Network.successSyncAllNoRedirect(data, (function () {
                          var match = state[/* isMounted */7][0];
                          if (match !== 0) {
                            return Curry._1(send, /* Loaded */1);
                          } else {
                            return /* () */0;
                          }
                        }));
          }));
    return Curry._1(send, /* Loading */2);
  };
  var newrecord = component.slice();
  newrecord[/* didMount */4] = (function (self) {
      var match = +(Network.pullWizardConfig(/* () */0) !== /* None */0);
      if (match === 0) {
        ReasonReact.Router[/* push */0]("/wizard/1");
      }
      syncNetworkData(self);
      return /* NoUpdate */0;
    });
  newrecord[/* willUnmount */6] = (function (self) {
      self[/* state */2][/* isMounted */7][0] = /* false */0;
      return /* () */0;
    });
  newrecord[/* render */9] = (function (self) {
      var week = String(self[/* state */2][/* week */0]);
      var points = String(self[/* state */2][/* points */3]);
      var pointsWeek = /* array */[
        String(Caml_array.caml_array_get(self[/* state */2][/* pointsWeek */4], 0)),
        String(Caml_array.caml_array_get(self[/* state */2][/* pointsWeek */4], 1)),
        String(Caml_array.caml_array_get(self[/* state */2][/* pointsWeek */4], 2)),
        String(Caml_array.caml_array_get(self[/* state */2][/* pointsWeek */4], 3))
      ];
      var showReset = Network.check16Completed(/* () */0) || +(Storage.fullDay(/* () */0) > 28);
      var x = self[/* state */2][/* fullDay */2];
      var match = self[/* state */2][/* show14 */8];
      var match$1 = self[/* state */2][/* show24 */9];
      var match$2 = 1 - self[/* state */2][/* knowledgeFresh */6];
      return React.createElement("div", {
                  className: dashboard
                }, React.createElement("img", {
                      className: pointsShield,
                      alt: "",
                      src: Points_shieldSvg
                    }), React.createElement("h1", {
                      className: pointsShieldH1
                    }, "" + (String(points) + "")), React.createElement("h3", {
                      className: pointsShieldH3
                    }, "pts."), React.createElement("div", {
                      className: headerBlock
                    }, x !== 0 ? (
                        x > 28 ? React.createElement("h3", {
                                className: horizontalBlockInner
                              }, "Programm abgeschlossen") : React.createElement("h3", {
                                className: horizontalBlockInner
                              }, "Woche " + (String(self[/* state */2][/* week */0]) + (", Tag " + String(self[/* state */2][/* day */1]))))
                      ) : React.createElement("h3", {
                            className: horizontalBlockInner
                          }, "Programm nicht gestartet")), React.createElement("div", {
                      className: contentBox
                    }, showReset !== 0 ? React.createElement("div", {
                            className: vertBlock
                          }, React.createElement("div", {
                                className: horizontalBlockTop
                              }, React.createElement("div", {
                                    className: headText
                                  }, "Programm beendet")), React.createElement("div", {
                                className: questionText
                              }, "Du hast das Programm abgeschlossen. Möchtest du deine Daten zurücksetzen und nochmals anfangen?"), React.createElement("div", {
                                className: horizontalBlockBottom
                              }, React.createElement("button", {
                                    className: smallerRedSecondaryButton(/* () */0),
                                    onClick: (function () {
                                        return Curry._1(self[/* send */4], /* Reset */3);
                                      })
                                  }, "Reset"))) : null, match !== 0 ? React.createElement("div", {
                            className: vertBlock
                          }, React.createElement("div", {
                                className: horizontalBlockTop
                              }, React.createElement("div", {
                                    className: headText
                                  }, "Anpassung Kalorienbedarf?")), React.createElement("div", {
                                className: questionText
                              }, "14 Tage sind geschafft! Du kannst nun deine tägliche Nahrungsaufnahme um 200 Kalorien reduzieren. Möchtest du die Änderung vornehmen?"), React.createElement("div", {
                                className: horizontalBlockBottom
                              }, React.createElement("button", {
                                    className: smallerRedSecondaryButton(/* () */0),
                                    onClick: (function () {
                                        return Curry._1(self[/* send */4], /* Send14 */Block.__(0, [/* true */1]));
                                      })
                                  }, "Ja"), React.createElement("button", {
                                    className: smallerRedSecondaryButton(/* () */0),
                                    onClick: (function () {
                                        return Curry._1(self[/* send */4], /* Send14 */Block.__(0, [/* false */0]));
                                      })
                                  }, "Nein"))) : null, match$1 !== 0 ? React.createElement("div", {
                            className: vertBlock
                          }, React.createElement("div", {
                                className: horizontalBlockTop
                              }, React.createElement("div", {
                                    className: headText
                                  }, "Anpassung Kalorienbedarf?")), React.createElement("div", {
                                className: questionText
                              }, "24 Tage sind geschaftt! Du kannst nun deine tägliche Nahrungsaufnahme um 200 Kalorien reduzieren. Möchtest du die Änderung vornehmen?"), React.createElement("div", {
                                className: horizontalBlockBottom
                              }, React.createElement("button", {
                                    className: smallerRedSecondaryButton(/* () */0),
                                    onClick: (function () {
                                        return Curry._1(self[/* send */4], /* Send24 */Block.__(1, [/* true */1]));
                                      })
                                  }, "Ja"), React.createElement("button", {
                                    className: smallerRedSecondaryButton(/* () */0),
                                    onClick: (function () {
                                        return Curry._1(self[/* send */4], /* Send24 */Block.__(1, [/* false */0]));
                                      })
                                  }, "Nein"))) : null, $$Array.mapi((function (i, param) {
                            var el = param[0];
                            var pointsWeekCur = Caml_array.caml_array_get(pointsWeek, i);
                            var match = +(week === el);
                            return React.createElement("div", {
                                        key: el,
                                        className: vertBlock
                                      }, React.createElement("div", {
                                            className: horizontalBlockTop
                                          }, React.createElement("div", {
                                                className: horizontalBlockInnerLeft
                                              }, React.createElement("img", {
                                                    className: calendarIcon,
                                                    alt: "",
                                                    src: Calendar_iconSvg
                                                  }), React.createElement("div", undefined, React.createElement("div", {
                                                        className: headText
                                                      }, "Woche " + (String(el) + "")))), React.createElement("div", {
                                                className: horizontalBlockInnerRight
                                              }, React.createElement("img", {
                                                    className: pointsStarIcon,
                                                    alt: "",
                                                    src: Points_star_iconSvg
                                                  }), React.createElement("div", {
                                                    className: headText
                                                  }, "" + (String(pointsWeekCur) + " pts.")))), React.createElement("div", {
                                            className: horizontalBlockBottom
                                          }, match !== 0 ? React.createElement("button", {
                                                  key: el + "1",
                                                  className: smallerRedSecondaryButtonHigh(/* () */0),
                                                  onClick: (function () {
                                                      return ReasonReact.Router[/* push */0]("/week/" + (el + "/workoutweek"));
                                                    })
                                                }, "Workouts") : React.createElement("button", {
                                                  key: el + "1",
                                                  className: smallerRedSecondaryButton(/* () */0),
                                                  onClick: (function () {
                                                      return ReasonReact.Router[/* push */0]("/week/" + (el + "/workoutweek"));
                                                    })
                                                }, "Workouts")));
                          }), /* array */[
                          /* tuple */[
                            "1",
                            "1"
                          ],
                          /* tuple */[
                            "2",
                            "8"
                          ],
                          /* tuple */[
                            "3",
                            "15"
                          ],
                          /* tuple */[
                            "4",
                            "21"
                          ]
                        ])), React.createElement("div", {
                      className: buttonBox
                    }, React.createElement("div", {
                          className: knowledgeWrapper
                        }, React.createElement("button", {
                              className: mediumGreenSecondaryButton(/* () */0),
                              onClick: (function () {
                                  return ReasonReact.Router[/* push */0]("/foodday/" + String(self[/* state */2][/* fullDay */2]));
                                })
                            }, React.createElement("img", {
                                  className: pointsStarIcon,
                                  alt: "",
                                  src: Mahlzeit_cta_iconSvg
                                }), "Mahlzeiten")), React.createElement("div", {
                          className: knowledgeWrapper
                        }, React.createElement("button", {
                              className: mediumGreenSecondaryButton(/* () */0),
                              onClick: (function () {
                                  return ReasonReact.Router[/* push */0]("/knowledge");
                                })
                            }, React.createElement("img", {
                                  className: pointsStarIcon,
                                  alt: "",
                                  src: Tipps_cta_iconSvg
                                }), "Tipps und Tricks", match$2 !== 0 ? React.createElement("div", {
                                    className: knowledgeInfo
                                  }, React.createElement("div", {
                                        className: knowledgeInfoContent
                                      }, "1")) : null)), React.createElement("div", {
                          className: knowledgeWrapper
                        }, React.createElement("button", {
                              className: mediumGreenSecondaryButton(/* () */0),
                              onClick: (function () {
                                  return ReasonReact.Router[/* push */0]("/settings");
                                })
                            }, "Einstellungen"))));
    });
  newrecord[/* initialState */10] = (function () {
      return /* record */[
              /* week */Storage.weekOfDay(/* () */0),
              /* day */Storage.weekDay(/* () */0),
              /* fullDay */Storage.fullDay(/* () */0),
              /* points */Network.calcPointsOverall(Network.pullPointsConfig(/* () */0)),
              /* pointsWeek : int array */[
                Network.calcPointsWeek(1),
                Network.calcPointsWeek(2),
                Network.calcPointsWeek(3),
                Network.calcPointsWeek(4)
              ],
              /* loading : false */0,
              /* knowledgeFresh */Caml_array.caml_array_get(Network.pullKnowledgeConfig(/* () */0), Storage.fullDayMax28(/* () */0)),
              /* isMounted */[/* true */1],
              /* show14 */Storage.show14(/* () */0),
              /* show24 */Storage.show24(/* () */0)
            ];
    });
  newrecord[/* reducer */12] = (function (action, state) {
      if (typeof action === "number") {
        switch (action) {
          case 0 : 
              return /* NoUpdate */0;
          case 1 : 
              return /* UpdateWithSideEffects */Block.__(3, [
                        /* record */[
                          /* week */Storage.weekOfDay(/* () */0),
                          /* day */Storage.weekDay(/* () */0),
                          /* fullDay */Storage.fullDay(/* () */0),
                          /* points */Network.calcPointsOverall(Network.pullPointsConfig(/* () */0)),
                          /* pointsWeek : int array */[
                            Network.calcPointsWeek(1),
                            Network.calcPointsWeek(2),
                            Network.calcPointsWeek(3),
                            Network.calcPointsWeek(4)
                          ],
                          /* loading : false */0,
                          /* knowledgeFresh */Caml_array.caml_array_get(Network.pullKnowledgeConfig(/* () */0), Storage.fullDayMax28(/* () */0)),
                          /* isMounted */[/* true */1],
                          /* show14 */Storage.show14(/* () */0),
                          /* show24 */Storage.show24(/* () */0)
                        ],
                        (function () {
                            console.log("loaded");
                            return /* () */0;
                          })
                      ]);
          case 2 : 
              var newrecord = state.slice();
              return /* UpdateWithSideEffects */Block.__(3, [
                        (newrecord[/* loading */5] = /* true */1, newrecord),
                        (function () {
                            console.log("loading");
                            return /* () */0;
                          })
                      ]);
          case 3 : 
              return /* SideEffects */Block.__(2, [(function () {
                            Network.resetAll(/* () */0);
                            return ReasonReact.Router[/* push */0]("/wizard/1");
                          })]);
          
        }
      } else if (action.tag) {
        var answer = action[0];
        var newrecord$1 = state.slice();
        return /* UpdateWithSideEffects */Block.__(3, [
                  (newrecord$1[/* show24 */9] = /* false */0, newrecord$1),
                  (function () {
                      if (answer !== 0) {
                        console.log("switch type");
                        Network.updateWizardCalsResultToLS(1100);
                        return Storage.store24(/* () */0);
                      } else {
                        return Storage.store24(/* () */0);
                      }
                    })
                ]);
      } else {
        var answer$1 = action[0];
        var newrecord$2 = state.slice();
        return /* UpdateWithSideEffects */Block.__(3, [
                  (newrecord$2[/* show14 */8] = /* false */0, newrecord$2),
                  (function () {
                      if (answer$1 !== 0) {
                        console.log("switch type");
                        Network.updateWizardCalsResultToLS(1500);
                        return Storage.store14(/* () */0);
                      } else {
                        return Storage.store14(/* () */0);
                      }
                    })
                ]);
      }
    });
  return newrecord;
}

exports.Styles = Styles;
exports.text = text;
exports.component = component;
exports.make = make;
/* card Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/dashboard.re
// module id = 134
// module chunks = 0